import React, { useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { customWhite, green } from "../constants/colors";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const AddPhotos = ({ images, setImages,bike,imagePaths }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    setImages(newFileList); // Directly set the new fileList
  };

  const beforeUpload = (file) => {
    // Prevent upload by returning false
    return false;
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: green,
        color:customWhite,
        display: "flex",
        alignItems: "center",
        padding: "5px 15px",
        borderRadius: "4px",
        width: "140px",
        margin:"auto",
        height: "35px",
        gap: "5px",
      }}
      type="button"
    >
      <PlusOutlined style={{ fontSize: "12px", fontWeight: 500 }} />
      <div>Add Photos</div>
    </button>
  );

  return (
    <>
      <p className="text-[12px] -mt-12 ms-8 text-center">
          ( Max limit <strong>5 MB</strong> per image )
        </p>
      <Upload
      accept=".png,.jpg,.jpeg,.gif"
        action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
        listType="picture-card"
        fileList={imagePaths?.length>0?images:[]} // Use imagePaths directly for fileList
        onPreview={handlePreview}
        onChange={handleChange}
        beforeUpload={beforeUpload}
        multiple={true} // Corrected to boolean
      >
        {uploadButton}
        {/* <p style={{ fontSize: "12px" }}>
          ( Max limit <strong>5 MB</strong> per image )
        </p> */}
      </Upload>
    

      <div className="flex justify-between items-center mt-20">
        <p className="text-[12px]">
          <strong> Adding at least 8 pictures</strong> improves <br /> the
          chances for a quick sale.
        </p>

        <p style={{ fontSize: "12px" }}>
          <strong>Adding clear Front, Back and Interior pictures</strong> of
          your {bike? "bike": "car"} <br /> increases the quality of your Ad and gets you noticed
          more.
        </p>
      </div>
      <div className="flex justify-between items-center mt-10">
        <p style={{ fontSize: "12px" }}>
          <strong>Pictures should be</strong> 882x484 centre frame image
        </p>
        <p className="text-[12px]">
          <strong> Photos should be</strong> in 'jpeg, jpg, png, gif' format
          only.
        </p>
      </div>

      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};

export default AddPhotos;
